export default class TutorialPlayerEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

TutorialPlayerEvent.NEXT_STEP = "TutorialPlayerEvent.NEXT_STEP";
TutorialPlayerEvent.COMPLETE_STEP = "TutorialPlayerEvent.COMPLETE_STEP";
TutorialPlayerEvent.COMPLETED = "TutorialPlayerEvent.COMPLETED";
TutorialPlayerEvent.REPLAY = "TutorialPlayerEvent.REPLAY";